import { render } from "./ProductOutboxQueueStatusFilter.vue?vue&type=template&id=5dc833c4"
import script from "./ProductOutboxQueueStatusFilter.vue?vue&type=script&lang=js"
export * from "./ProductOutboxQueueStatusFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__